import { RegulatoryDutyCategory } from "../../../types/api.types";
import type { Todo } from "../../../utils/backend-types";
import { TABS } from "../TodoModal/TodoModal";

/**
 * Returns the default tab for a todo modal. Todos based on premium
 * regulatory duties default to the description tab because their
 * documents tab is mostly irrelevant, since premium sites are still in
 * planning. All other todos default to the documents tab.
 */
export function getDefaultTodoTab(todo: Todo): string {
  return todo.regulatoryDuty?.category === RegulatoryDutyCategory.Premium
    ? TABS.DESCRIPTION
    : TABS.DOCUMENTS;
}
